let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ly7Bv")).then(() => parcelRequire('6owjL'));